/** @typedef {import("./SyosController").default} SyosController */

class SyosUiContainer {
  /**
   * @param {SyosController} syosController
   * @param {string} containerSelector
   */
  constructor(syosController, containerSelector = null) {
    this.syosController = syosController;

    if (containerSelector !== null) {
      this.$el = this.syosController.find(containerSelector);
    }
  }

  on(event, handler) {
    this.syosController.on(event, handler);
  }

  off(event, handler) {
    this.syosController.removeListener(event, handler);
  }

  find(selector) {
    return this.$el.find(selector);
  }
}

export default SyosUiContainer;



// WEBPACK FOOTER //
// ./src/syos/SyosUiContainer.js